var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hots"},[_c('img',{staticClass:"hots_bg",attrs:{"src":_vm.moData.img}}),_vm._l((_vm.moData.hots),function(item,index){return [_c('i',{key:index,staticClass:"hots_area",style:({
        top: item.topPer * 100 + '%',
        left: item.leftPer * 100 + '%',
        width: item.widthPer * 100 + '%',
        height: item.heightPer * 100 + '%',
      }),on:{"click":function($event){return _vm.getModelPath(item.url)}}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }